module.exports = Redux;


//////////////////
// WEBPACK FOOTER
// external "Redux"
// module id = 31
// module chunks = 0